import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal } from "./Reveal";

export default function Collection() {
  return (
    <section id="collection" data-testid="collection-section" className="px-6 py-24 md:py-32">
      <Reveal className="mx-auto max-w-3xl text-center">
        <p className="mb-6 font-mono text-[11px] uppercase tracking-[0.5em] text-gold">
          The First Collection
        </p>
        <h2 className="font-serif text-3xl font-light text-neutral-100 sm:text-4xl lg:text-5xl">
          Essence of <em className="text-gold-light">Strength</em>
        </h2>
        <p className="mx-auto mt-6 max-w-md text-base font-light leading-relaxed text-neutral-400">
          Two debut fragrances — Guardian and Legacy — composed in honour of a lasting legacy.
        </p>
        <Link
          to="/shop"
          data-testid="discover-collection-link"
          className="group mt-10 inline-flex items-center gap-3 border border-gold/40 px-8 py-4 text-[11px] uppercase tracking-[0.25em] text-gold-light transition-all duration-500 hover:border-gold hover:bg-gold/10"
        >
          Discover the collection
          <ArrowRight className="h-3.5 w-3.5 transition-transform duration-300 group-hover:translate-x-1" strokeWidth={1.5} />
        </Link>
      </Reveal>
    </section>
  );
}
